//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//
export default {
  name: 'UrlInput',
  props: {
    testServer: {default: ''}
  },
  data() {
    return {
      ipInput: {
        ip0: '',
        ip1: '',
        port: ''
      },
      ipCustom: ''
    }
  },
  /*----------------------------------------- 生命周期 -----------------------------------------*/
  mounted() {
    this.loadHistoryText()
  },
  methods: {
    /*----------------------------------------- 绑定方法 -----------------------------------------*/
    /*  跳转点击
      * */
    linkToClick() {
      const {ip0, ip1, port} = this.ipInput

      localStorage.setItem('ipInput', JSON.stringify(this.ipInput)) // 保存
      this.locationTo(`http://192.168.${ip0}.${ip1}:${port}`)
    },

    /*  跳转到自定义点击
      * */
    linkToCustomClick() {
      localStorage.setItem('ipCustom', this.ipCustom) // 保存
      this.locationTo(this.ipCustom)
    },

    /*----------------------------------------- 自定义方法 -----------------------------------------*/
    /**
     * 加载历史文本
     */
    loadHistoryText() {
      // 自动填写资料
      const ipInputStr = localStorage.getItem('ipInput')
      if (ipInputStr) this.ipInput = JSON.parse(ipInputStr)
      const ipCustomStr = localStorage.getItem('ipCustom')
      if (ipCustomStr) this.ipCustom = ipCustomStr
    },

    /**
     * 跳转。参数带上
     */
    locationTo(link) {
      location.href = `${link}?${location.search}`
    }
  }
}



// WEBPACK FOOTER //
// ./src/items/DebugBlock/UrlInput.vue